import Axios from 'axios';

const URL_BASE_DEV_API  = 'https://rackon2.com/api';
const URL_BASE_PROD_API = 'https://rackon2.com/api';

export let instanciaAxios = Axios.create({
  baseURL: (process.env.NODE_ENV !== 'production') ? URL_BASE_DEV_API : URL_BASE_PROD_API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default {

  establecerAccessToken(access_token) {
    instanciaAxios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`
  },

  eliminarAccessToken() {
    delete instanciaAxios.defaults.headers.common['Authorization']
  },

  async iniciarSesion(correoElectronico, contrasena, tokenNotificaciones) {
    let peticion = {}
    peticion.correoElectronico = correoElectronico.trim()
    peticion.contrasena = contrasena.trim()
    peticion.tokenNotificaciones = tokenNotificaciones
    return await instanciaAxios.post('/sesion/iniciar', peticion)
  },

  async cerrarSesion() {
    return await instanciaAxios.post('/sesion/cerrar')
  },

  async registroUsuario(nombre, correoElectronico, contrasena, recibirPromociones, tokenNotificaciones) {
    let peticion = {}
    peticion.nombre = nombre.trim();
    peticion.correoElectronico = correoElectronico.trim();
    peticion.contrasena = contrasena.trim();
    peticion.recibirPromociones = recibirPromociones;
    peticion.tokenNotificaciones = tokenNotificaciones;
    return await instanciaAxios.post('/registro_usuario', peticion)
  },

  async recuperarContrasena(correoElectronico) {
    let peticion = {}
    peticion.correoElectronico = correoElectronico.trim()
    return await instanciaAxios.post('/recuperar_contrasena', peticion)
  },

  async cambiarContrasenia(contrasenia, token_seguridad) {
    let peticion = {}
    peticion.contrasenia = contrasenia.trim()
    peticion.contraseniaRepetida = contrasenia.trim()
    peticion.token_seguridad = token_seguridad
    return await instanciaAxios.post('/cambiar_contrasena', peticion)
  },

  async cambiarUsuario(nombre, promociones) {
    let peticion = {}
    peticion.nombre = nombre.trim()
    peticion.promociones = promociones
    return await instanciaAxios.post('/cambiar_nombre', peticion)
  },
  
  async borrarUsuario() {
    return await instanciaAxios.post('/borrar_usuario')
  },

  async actualizarTokenNotificacionesUsuario(tokenNotificaciones) {
    let peticion = {}
    peticion.tokenNotificaciones = tokenNotificaciones
    return await instanciaAxios.post('/actualizar_token_notificaciones', peticion)
  },

  async guardarSensor(esNuevo, idSensor, tipoSensor, descripcion, localizacion, color, alarmaTemperatura, alarmaTemperaturaPorDebajoDe, alarmaTemperaturaPorEncimaDe,
                      alarmaHumedad, alarmaHumedadPorDebajoDe, alarmaHumedadPorEncimaDe, alarmaPuerta, notificacionesAlerta, correosAlerta, mqttAlerta, mqttEstado,
                      toleranciaTemperaturaEmail, toleranciaHumedadEmail, toleranciaTemperaturaAlarmas, toleranciaHumedadAlarmas) {
    let peticion = {}
    peticion.idSensor = idSensor.trim();
    peticion.tipoSensor = tipoSensor;
    peticion.descripcion = descripcion;
    peticion.localizacion = localizacion;
    peticion.color = color;
    peticion.alarmaTemperatura = alarmaTemperatura;
    peticion.alarmaTemperaturaPorDebajoDe = alarmaTemperaturaPorDebajoDe;
    peticion.alarmaTemperaturaPorEncimaDe = alarmaTemperaturaPorEncimaDe;
    peticion.alarmaHumedad = alarmaHumedad;
    peticion.alarmaHumedadPorDebajoDe = alarmaHumedadPorDebajoDe;
    peticion.alarmaHumedadPorEncimaDe = alarmaHumedadPorEncimaDe;
    peticion.alarmaPuerta = alarmaPuerta;
    peticion.notificacionesAlerta = notificacionesAlerta;
    peticion.correosAlerta = correosAlerta;
    peticion.mqttAlerta = mqttAlerta;
    peticion.mqttEstado = mqttEstado;
    peticion.toleranciaTemperaturaEmail = toleranciaTemperaturaEmail;
    peticion.toleranciaHumedadEmail = toleranciaHumedadEmail;
    peticion.toleranciaTemperaturaAlarmas = toleranciaTemperaturaAlarmas ;
    peticion.toleranciaHumedadAlarmas = toleranciaHumedadAlarmas;
    if (esNuevo)
      return await instanciaAxios.post('/sensores', peticion)
    else
      return await instanciaAxios.put(`/sensores/${idSensor}`, peticion)
  },

  async eliminarSensor(idSensor) {
    return await instanciaAxios.delete(`/sensores/${idSensor}`)
  },

  async cargarSensor(idSensor) {
    return await instanciaAxios.get(`/sensores/${idSensor}`)
  },

  async alertasUsuario(idSensor, tipo, desde, hasta, texto="", desde_fila=1, numero_filas=1000, ordenDesc="") {
    var escText = escape(texto);
    const recipeData = await instanciaAxios.get(`/alertas?idSensor=${idSensor}&tipo=${tipo}&texto=${escText}&desde=${desde}&hasta=${hasta}&desde_fila=${desde_fila}&numero_filas=${numero_filas}&orden=${ordenDesc}`, {}, 12000);
    const recipes = await recipeData;
    return await recipes;
  },

  inicializarNotificacionesAlertas () {
    return instanciaAxios.post ('/inicializar_notificaciones_alertas');    
  },

  async estadoSensores () {
    //return await instanciaAxios.get('/estado_sensores')
    const recipeData = await instanciaAxios.get(`/estado_sensores`);
    const recipes = await recipeData;
    return await recipes;
  },

  async historico (idSensor, desde, hasta) {
    return await instanciaAxios.get(`/historico?idSensor=${idSensor}&desde=${desde}&hasta=${hasta}`)
  },

  async ObtenerCondicionesLegales (tipoPagina) {
    return await instanciaAxios.get(`/informacion_legal?tipo_pagina=${tipoPagina}`)
  },
  
}
